import React, { useState } from 'react';

const CARD_ICON_CLASS = 'h-5 w-5 sm:h-7 sm:w-7 shrink-0 rounded-md object-contain';

/** Prefer committed PNG; fall back to SVG if PNG is missing. */
const BrandIcon: React.FC<{ pngSrc: string; svgSrc: string; className?: string }> = ({
  pngSrc,
  svgSrc,
  className
}) => {
  const [src, setSrc] = useState(pngSrc);
  return (
    <img
      src={src}
      alt=""
      aria-hidden
      className={className ?? CARD_ICON_CLASS}
      onError={() => {
        if (src !== svgSrc) {
          setSrc(svgSrc);
        }
      }}
    />
  );
};

export const GoogleAuthenticatorIcon: React.FC<{ className?: string }> = ({ className }) => (
  <BrandIcon
    pngSrc="/images/2fa/google-authenticator.png"
    svgSrc="/images/2fa/google-authenticator.svg"
    className={className ?? CARD_ICON_CLASS}
  />
);

export const BaleIcon: React.FC<{ className?: string }> = ({ className }) => (
  <BrandIcon
    pngSrc="/images/2fa/bale.png"
    svgSrc="/images/2fa/bale.svg"
    className={className ?? CARD_ICON_CLASS}
  />
);

/** Telegram brand mark. */
export const TelegramIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className ?? 'h-5 w-5 sm:h-7 sm:w-7 shrink-0'} aria-hidden role="img">
    <circle cx="12" cy="12" r="12" fill="#26A5E4" />
    <path
      fill="#fff"
      d="M5.45 11.97c3.02-1.31 5.04-2.18 6.06-2.61 2.88-1.2 3.48-1.41 3.87-1.42.09 0 .28.02.4.12.1.08.13.19.15.27.01.08.03.27.01.42-.19 1.98-.99 6.78-1.4 9-.17.98-.51 1.31-.84 1.34-.71.06-1.25-.47-1.94-.92-1.08-.72-1.69-1.17-2.74-1.87-1.21-.81-.43-1.26.27-1.99.18-.19 3.35-3.07 3.41-3.33.01-.03.01-.14-.05-.2-.06-.06-.15-.04-.21-.02-.09.02-1.46.93-4.12 2.73-.39.27-.74.4-1.06.39-.35-.01-1.02-.2-1.52-.36-.61-.2-1.09-.31-1.05-.66.02-.15.23-.31.63-.47z"
    />
  </svg>
);

export const EmailMethodIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className ?? 'h-5 w-5 sm:h-7 sm:w-7 shrink-0'} aria-hidden role="img" fill="none">
    <rect x="2" y="5" width="20" height="14" rx="2" stroke="#64748b" strokeWidth="1.8" />
    <path d="m3 7 9 6 9-6" stroke="#64748b" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CARD_METHOD_ICON_CLASS = CARD_ICON_CLASS;
